export function scopeHtmlStyles(
  htmlString: string,
  scopeSelector: string,
): string {
  return htmlString.replace(
    /<style([^>]*)>([\s\S]*?)<\/style>/gi,
    (_, attributes, cssContent) => {
      // Process the CSS content to scope selectors
      const scopedCss = cssContent.replace(
        /([^{}]+)\{([^}]*)\}/g,
        (_: string, selectors: string, rules: string) => {
          // Split multiple selectors (e.g. "td, br")
          const scopedSelectors = selectors
            .split(',')
            .map((sel: string) => {
              sel = sel.trim();

              // Skip empty selectors
              if (!sel) return sel;

              // Avoid double-scoping @rules (like @media, @keyframes)
              if (sel.startsWith('@')) {
                return sel;
              }

              return `${scopeSelector} ${sel}`;
            })
            .filter(Boolean)
            .join(', ');

          return `${scopedSelectors} {${rules}}`;
        },
      );

      return `<style${attributes}>${scopedCss}</style>`;
    },
  );
}
